import React from "react";

import { Icon } from "@culturehq/components";

import celebrate from "images/social/linkedin/celebrate.svg";
import curious from "images/social/linkedin/curious.svg";
import insightful from "images/social/linkedin/insightful.svg";
import laugh from "images/social/linkedin/laugh.svg";
import like from "images/social/linkedin/like.svg";
import love from "images/social/linkedin/love.svg";
import support from "images/social/linkedin/support.svg";

const LinkedinReactionIcon = ({ reaction }) => {
  switch (reaction?.reactionType || reaction?.message) {
    case "LIKE":
      return <img className="Linkedin-Reaction" src={like} alt="Like" />;
    case "PRAISE":
      return <img className="Linkedin-Reaction" src={celebrate} alt="Celebrate" />;
    case "MAYBE":
      return <img className="Linkedin-Reaction" src={curious} alt="Curious" />;
    case "EMPATHY":
      return <img className="Linkedin-Reaction" src={love} alt="Love" />;
    case "INTEREST":
      return <img className="Linkedin-Reaction" src={insightful} alt="Insightful" />;
    case "APPRECIATION":
      return <img className="Linkedin-Reaction" src={support} alt="Support" />;
    case "ENTERTAINMENT":
      return <img className="Linkedin-Reaction" src={laugh} alt="Funny" />;
    default:
      return <Icon icon="linkedin-thumbsup" />;
  }
};

export default LinkedinReactionIcon;
